module.exports = __webpack_public_path__ + "img/frowning_face.8db003a2.gif";